import { defineMessages, type IntlShape } from 'react-intl';
import logError from '@alltrails/core/utils/logError';
import TrailTraffic from '../types/TrailTraffic';

const messages = defineMessages<TrailTraffic>({
  light: { defaultMessage: 'Light' },
  moderate: { defaultMessage: 'Moderate' },
  heavy: { defaultMessage: 'Heavy' }
});

export default function getTrailTrafficLabel(intl: IntlShape, trailTraffic: TrailTraffic): string {
  const message = messages[trailTraffic];

  if (message) {
    return intl.formatMessage(message);
  }

  logError(new Error(`Unknown trail traffic: ${trailTraffic}`));
  return '';
}
